import { notification } from 'antd'
import articleService from '../services/article'
import checkModerationService from '../services/checkModeration'
import {
  GET_ONE_ARTICLE,
  LIKE_ARTICLE,
  UNLIKE_ARTICLE,
  UNBOOKMARK_ARTICLE,
  BOOKMARK_ARTICLE,
  FOLLOWUSER,
  UNFOLLOWUSER,
  CREATE_COMMENT,
  DELETE_COMMENT,
  CLEAR
} from '../actions/articlePage'

const articlePage = (state = {}, action) => {
  switch (action.type) {
    case GET_ONE_ARTICLE:
      return action.data
    case LIKE_ARTICLE:
      return { ...state, islike: true, length: state.length + 1 }
    case UNLIKE_ARTICLE:
      return { ...state, islike: false, length: state.length - 1 }
    case BOOKMARK_ARTICLE:
      return { ...state, isBooked: true }
    case CLEAR:
      return {}
    case UNBOOKMARK_ARTICLE:
      return { ...state, isBooked: false }
    case FOLLOWUSER:
      return { ...state, isFollow: true }
    case UNFOLLOWUSER:
      return { ...state, isFollow: false }
    case CREATE_COMMENT:
      return { ...state, comments: state.comments.concat({ ...action.data }) }
    case DELETE_COMMENT:
      return {
        ...state,
        comments: state.comments.filter((comment) => {
          return comment !== action.data
        })
      }

    default:
      return state
  }
}

export const clear = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: CLEAR })
    } catch (e) {
      console.log(e)
    }
  }
}

export const getArticleData = (id) => {
  return async (dispatch) => {
    try {
      const response = await articleService.getThisArticle(id)
      dispatch({ type: GET_ONE_ARTICLE, data: response })
    } catch (e) {
      notification.error({
        message: 'Failed get data of article'
      })
    }
  }
}

export const likeArticle = (id) => {
  return async (dispatch) => {
    try {
      const response = await articleService.likeArticle(id)
      dispatch({ type: LIKE_ARTICLE, data: response })
      notification.success({
        message: 'You liked this article'
      })
    } catch (error) {
      notification.error({
        message: 'failed to like article'
      })
      console.log(error)
    }
  }
}

export const unlikeArticle = (id) => {
  return async (dispatch) => {
    try {
      const response = await articleService.UnlikeArticle(id)
      dispatch({ type: UNLIKE_ARTICLE, data: response })

      notification.success({
        message: 'You unliked this article'
      })
    } catch (e) {
      notification.error({
        message: 'failed to unlike article'
      })
      console.log(e)
    }
  }
}

export const BookMark = (id) => {
  return async (dispatch) => {
    try {
      const response = await articleService.BookMark(id)
      dispatch({ type: BOOKMARK_ARTICLE, data: response })
      notification.success({
        message: 'You bookmarked this article.'
      })
    } catch (e) {
      notification.error({
        message: 'Failed to book article'
      })
    }
  }
}

export const unBookMark = (id) => {
  return async (dispatch) => {
    try {
      const response = await articleService.unBookMark(id)
      dispatch({ type: UNBOOKMARK_ARTICLE, data: response })

      notification.success({
        message: 'This article is no longer bookmarked.'
      })
    } catch (e) {
      notification.error({
        message: 'Failed to unbook article'
      })
    }
  }
}

export const followUser = (id) => {
  return async (dispatch) => {
    try {
      const response = await articleService.followUser(id)
      dispatch({ type: FOLLOWUSER, data: response })
      notification.success({
        message: "You are now following this author's article page."
      })
    } catch (e) {
      notification.error({
        message: "Failed to follow author's article page"
      })
      console.log('error', e)
    }
  }
}

export const unfollowUser = (id) => {
  return async (dispatch) => {
    try {
      const response = await articleService.unfollow(id)
      dispatch({ type: UNFOLLOWUSER, data: response })
      notification.success({
        message: "You’re no longer following this author's article page"
      })
    } catch (e) {
      notification.error({
        message: "Failed to unfollow author's article page"
      })
    }
  }
}

export const createComment = (articleId, comment) => {
  return async (dispatch) => {
    try {
      const ver = await checkModerationService.check(comment)
      if (ver) {
        await articleService.createComment(articleId, comment)

        dispatch({ type: CREATE_COMMENT, data: comment })
        notification.success({
          message: 'Your comment is posted on this article.'
        })
      } else {
        notification.error({
          message: 'Your comment violates Spanidea standards'
        })
      }
    } catch (e) {
      notification.error({
        message: 'Failed to post comment'
      })
    }
  }
}

export const DeleteComment = (articleId, comment) => {
  return async (dispatch) => {
    try {
      if (comment.id !== undefined) {
        await articleService.deleteComment(articleId, comment.id)
      }
      dispatch({ type: DELETE_COMMENT, data: comment })
      notification.success({
        message: 'Your comment is no longer posted on this article.'
      })
    } catch (e) {
      notification.error({
        message: 'Failed to delete comment'
      })
      console.log(e)
    }
  }
}

export default articlePage
